import React from "react";
import { useParams } from "react-router-dom";
import CustomerAccountDetail from "./CustomerAccountDetail"; 

const CustomerAccountDetailPage: React.FC = () => {
  const { userId } = useParams<{ userId: string }>();

  return (
    <CustomerAccountDetail
      userId={userId ? Number(userId) : null}
    />
  );
};

export default CustomerAccountDetailPage;
